import { render, staticRenderFns } from "./ContactEditView.vue?vue&type=template&id=3cc7f44d&"
import script from "./ContactEditView.vue?vue&type=script&lang=js&"
export * from "./ContactEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports